var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkingActiveIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    viewBox: "0 0 26 26",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: ".7px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.752 14.328-0.763 0.193c-0.864 0.219-1.555 0.866-1.83 1.714l-1.255 3.877c-0.274 0.846-0.094 1.773 0.478 2.454l0.628 0.748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.938 23.314 0.627-0.748c0.572-0.681 0.753-1.608 0.479-2.454l-1.256-3.877c-0.275-0.848-0.966-1.495-1.83-1.714l-0.762-0.193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.104 25h-22.261c-0.465 0-0.843-0.377-0.843-0.843s0.378-0.843 0.843-0.843h22.261c0.466 0 0.843 0.377 0.843 0.843s-0.377 0.843-0.843 0.843z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.607 18.724v3.214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.341 21.938v-7.051c0-0.152-0.03-0.297-0.083-0.43-0.171-0.422-0.584-0.72-1.067-0.72h-10.434c-0.635 0-1.15 0.515-1.15 1.15v2.145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.964 11.134-0.238 1.593c-0.055 0.375-0.331 0.68-0.698 0.773l-0.939 0.237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.859 13.737-0.939-0.237c-0.368-0.093-0.643-0.398-0.699-0.773l-0.237-1.593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.457 23.314c0.245-0.257 0.396-0.605 0.396-0.987 0-0.215-0.174-0.389-0.389-0.389h-14.981c-0.215 0-0.389 0.174-0.389 0.389 0 0.382 0.151 0.73 0.396 0.987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.269 17.878c0 0.715-0.58 1.295-1.295 1.295-0.716 0-1.296-0.58-1.296-1.295 0-0.716 0.58-1.296 1.296-1.296 0.715 0 1.295 0.58 1.295 1.296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.313 1h-0.014c-0.751 2e-3 -1.355 0.622-1.355 1.373v0.022c0 2.077 1.684 3.761 3.761 3.761h3.285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.244 3.868v0.244c0 0.722-0.585 1.307-1.307 1.307-0.386 0-0.698 0.314-0.696 0.699l9e-3 1.943c0 2.476 2.599 3.858 3.724 3.883 1.125-0.025 3.724-1.407 3.724-3.883l5e-3 -1.905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.989 10.145 2e-3 -4.785c2e-3 -2.407-1.949-4.36-4.357-4.36h-1.321c-2.407 0-4.358 1.953-4.356 4.36l2e-3 8.377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.988 13.737 1e-3 -1.898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.241 6.156h-0.596c-0.38 0-0.688 0.308-0.688 0.688v0.814c0 0.38 0.308 0.689 0.689 0.689h0.616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.686 8.347h0.616c0.38 0 0.688-0.309 0.688-0.689v-0.814c0-0.38-0.308-0.688-0.688-0.688h-0.599"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingActiveIc);
export default __webpack_public_path__ + "static/media/working-active-ic.6a9beaf502a7c71ba8e4a0ad4316efd4.svg";
export { ForwardRef as ReactComponent };